<!-- src/components/notifications/NotificationBell.vue -->
<template>
  <v-menu offset-y left :close-on-content-click="false" max-width="380" @input="onMenuOpen">
    <template #activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" :aria-label="$t('notifications.title')" data-testid="notification-bell-btn">
        <v-badge :value="unseenCount > 0" :content="unseenCount" color="error" overlap data-testid="notification-badge">
          <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
      </v-btn>
    </template>

    <v-list dense max-height="420" class="overflow-y-auto">
      <v-list-item v-if="items.length === 0">
        <v-list-item-content>
          <v-list-item-title class="text--secondary">{{ $t("notifications.empty") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <template v-for="n in items">
        <v-list-item :key="n.id" @click="openNotification(n)" :class="{ 'font-weight-bold': !n.read_at }">
          <v-list-item-icon><v-icon>{{ n.icon || "mdi-bell-outline" }}</v-icon></v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ n.title }}</v-list-item-title>
            <v-list-item-subtitle>{{ n.body }}</v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action>
            <span class="text-caption text--secondary">{{ formatTime(n.created_at) }}</span>
          </v-list-item-action>
        </v-list-item>
        <v-divider :key="`d-${n.id}`" />
      </template>

      <v-list-item v-if="unreadCount > 0" @click="markAll">
        <v-list-item-title>{{ $t("notifications.mark_all_read") }}</v-list-item-title>
      </v-list-item>
      <v-list-item to="/notifications">
        <v-list-item-title class="primary--text">{{ $t("notifications.see_all") }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CableSubscriber from "@/mixins/CableSubscriber";

export default {
  name: "NotificationBell",
  mixins: [CableSubscriber],
  computed: {
    ...mapGetters("notifications", { items: "notifications", unseenCount: "unseenCount" }),
    unreadCount() { return this.$store.getters["notifications/unreadCount"]; },
  },
  created() {
    // 401 при загрузке (сессия уже закончилась) решает общий обработчик — здесь без необработанного promise.
    this.fetchNotifications({ page: 1, perPage: 20 }).catch(() => {});
  },
  mounted() {
    // Per-user stream; server resolves current_user from the cable JWT (main.js).
    this.notificationsSub = this.$cableSubscribe(
      { channel: "NotificationsChannel" },
      {
        connected: () => this.onNotificationsConnected(),
        rejected: () => this.onNotificationsRejected(),
        received: (data) => this.onNotificationsReceived(data),
      },
    );
  },
  // NotificationsChannel sub auto-unsubscribed by CableSubscriber mixin.
  methods: {
    ...mapActions("notifications", ["fetchNotifications", "markSeen", "markRead", "markAllRead"]),
    onNotificationsConnected() {},
    onNotificationsRejected() {},
    onNotificationsReceived(data) {
      if (!data || !data.notification) return;
      this.$store.dispatch("notifications/prependNotification", {
        notification: data.notification,
        unseenCount: data.unseen_count,
      });
    },
    async onMenuOpen(open) {
      if (open && this.unseenCount > 0) await this.markSeen();
    },
    async openNotification(n) {
      if (!n.read_at) await this.markRead(n.id);
      if (n.url) this.$router.push(n.url);
    },
    async markAll() { await this.markAllRead(); },
    formatTime(ts) { return ts ? new Date(ts).toLocaleString() : ""; },
  },
};
</script>
